import { memoize } from "lodash";
import { observable, runInAction } from "mobx";
import getKhattabatSharedMessagingStore from "../messaging-stores/conversation-messaging-store";
import getKhattabat101MatchStore from ".";
import getKhattabatStore from "..";
import { TKhattabatMessage } from "../../../Types";
import getCorePersonalStore from "../../core/core-personal-store";
import { apiCallGetOneOOneMMessages } from "../../../api/khattbat-api/api-call-get-one-one-m-messages";
import getCorePopUpStore from "../../core/core-popup-store";
import getCoreUIStore from "../../core/core-ui-store";
import { apiCallSetOneOOneHighLight } from "../../../api/khattbat-api/api-call-set-one-o-one-highlight";
import { apiCallSetOneOOneMSlackAlert } from "../../../api/khattbat-api/api-call-set-one-o-one-m-slack-alert";
import getKhattabatFilterStore from "../filter-store";
import { apiCallSetOneOOneMessagesSeen } from "../../../api/khattbat-api/api-call-set-one-o-one-messages-seen";
import getKhattabat101MessagingStore from "../messaging-stores/101-messaging-store";

class Khattabat101MMessagingStore {
  matchID = observable.box<number>(0);

  updateConversation = ({
    messages,
    comments
  }: {
    messages: TKhattabatMessage[];
    comments: TKhattabatMessage[];
  }) => {
    const match101MStore = getKhattabat101MatchStore(this.matchID.get());
    runInAction(() => {
      const alkhattabaUUID = getKhattabatStore().alkhattabaUUID.get();
      const alkhattabaUser = getCorePersonalStore().user.get();

      const sharedStore = getKhattabatSharedMessagingStore(
        match101MStore.conversationID.get()
      );
      const messagingStore = getKhattabat101MessagingStore(
        match101MStore.conversationID.get()
      );
      sharedStore.conversationType.set("101M");
      messagingStore.receiverID.set(match101MStore.matchID.get());
      messagingStore.receiverUUID.set(match101MStore.matchUUID.get());
      messagingStore.receiverName.set(match101MStore.matchUserName.get());
      messagingStore.senderID.set(alkhattabaUser.id);
      messagingStore.senderUUID.set(alkhattabaUUID);
      messagingStore.senderName.set(alkhattabaUser.fullName);
      sharedStore.updateMessages(messages);

      const { conversationType, updateMessages } =
        getKhattabatSharedMessagingStore(
          `${match101MStore.conversationID.get()}_COMMENTS`
        );
      const {
        receiverID,
        receiverUUID,
        receiverName,
        senderID,
        senderUUID,
        senderName
      } = getKhattabat101MessagingStore(
        `${match101MStore.conversationID.get()}_COMMENTS`
      );
      conversationType.set("101M_COMMENTS");
      receiverID.set(match101MStore.matchID.get());
      receiverUUID.set(match101MStore.matchUUID.get());
      receiverName.set(match101MStore.matchUserName.get());
      senderID.set(alkhattabaUser.id);
      senderUUID.set(alkhattabaUUID);
      senderName.set(alkhattabaUser.fullName);
      updateMessages(comments);
    });
  };

  updateOneOOneMMessages = async ({ shouldLoad }: { shouldLoad: boolean }) => {
    getCoreUIStore().setIsLoading("KHATTABAT_MATCHING_RESULTS", shouldLoad);
    const { status, code, data } = await apiCallGetOneOOneMMessages({
      matchID: this.matchID.get()
    });
    getCoreUIStore().setIsLoading("KHATTABAT_MATCHING_RESULTS", false);
    if (status === "OK") {
      this.updateConversation({
        messages: data.oneOOneMMessages,
        comments: data.oneOOneMComments
      });
      return;
    } else {
      getCorePopUpStore().showAlertMessage(code);
    }
  };

  toggleConversationOpenState = async () => {
    const conversationID = getKhattabat101MatchStore(
      this.matchID.get()
    ).conversationID.get();
    const currentState =
      getKhattabatSharedMessagingStore(conversationID).isOpened.get() ===
      "OPENED";
    if (!currentState) {
      await this.updateOneOOneMMessages({ shouldLoad: true });
    }
    runInAction(() => {
      getKhattabatSharedMessagingStore(conversationID).isOpened.set(
        !currentState ? "OPENED" : "CLOSED"
      );
    });
  };

  updateMatchConversationEnablementState = ({
    oldState
  }: {
    oldState: boolean;
  }) => {
    runInAction(() => {
      getKhattabat101MatchStore(
        this.matchID.get()
      ).matchConvesationIsDisabled.set(!oldState);
    });
  };

  updateMatchConversationDeletionState = ({
    oldState
  }: {
    oldState: boolean;
  }) => {
    getKhattabat101MatchStore(this.matchID.get()).setConversationDeletionState(
      !oldState
    );
  };

  updateOneOOneMIsHighlightedDataBase = async () => {
    const match101MStore = getKhattabat101MatchStore(this.matchID.get());
    const conversationID = match101MStore.conversationID.get();
    const currentHightlightState =
      match101MStore.matchConversationIsHighlighted.get();
    const { status, code } = await apiCallSetOneOOneHighLight({
      conversationID,
      newState: currentHightlightState ? 0 : 1,
      conversationType: "101M"
    });
    if (status === "OK") {
      runInAction(() => {
        match101MStore.matchConversationIsHighlighted.set(
          !currentHightlightState
        );
      });
      getKhattabatFilterStore().update1o1MFilter();
    } else {
      getCorePopUpStore().showAlertMessage(code);
    }
  };

  updateOneOOneMSlackAlertsDataBase = async () => {
    const match101MStore = getKhattabat101MatchStore(this.matchID.get());
    const conversationID = match101MStore.conversationID.get();
    const currentEnabledSlacktState =
      match101MStore.matchIsSlackAlertsEnabled.get();
    const { status, code } = await apiCallSetOneOOneMSlackAlert({
      conversationID,
      newState: currentEnabledSlacktState ? 0 : 1
    });
    if (status === "OK") {
      runInAction(() => {
        match101MStore.matchIsSlackAlertsEnabled.set(
          !currentEnabledSlacktState
        );
      });
    } else {
      getCorePopUpStore().showAlertMessage(code);
    }
  };

  handleMessageSent = ({
    conversationID,
    oneOOneMessageToAdd
  }: {
    conversationID: string;
    oneOOneMessageToAdd: TKhattabatMessage;
  }) => {
    getKhattabatSharedMessagingStore(conversationID).appendMessage(
      oneOOneMessageToAdd
    );
    this.updateMatchConversationEnablementState({ oldState: true });
    this.updateMatchConversationDeletionState({ oldState: true });
  };

  markMessagesSeen = async () => {
    const matchID = this.matchID.get();
    const { status, code } = await apiCallSetOneOOneMessagesSeen({
      userID: matchID,
      conversationType: "101M"
    });
    if (status === "OK") {
      getKhattabatSharedMessagingStore(
        getKhattabat101MatchStore(matchID).conversationID.get()
      ).setUnreadMessagesCounter(0);
    } else {
      getCorePopUpStore().showAlertMessage(code);
    }
  };
}

const getKhattabat101MMessagingStore = memoize((matchID: number) => {
  const store = new Khattabat101MMessagingStore();
  store.matchID.set(matchID);
  return store;
});
export default getKhattabat101MMessagingStore;
